// extracted by mini-css-extract-plugin
export var list = "RuledList-module--list--qZ6Qc";
export var item = "RuledList-module--item--TQk4j";
export var ruleTop = "RuledList-module--ruleTop--BsSFZ";
export var ruleBottom = "RuledList-module--ruleBottom--JcSpa";